import { render, staticRenderFns } from "./send-add-mobile.vue?vue&type=template&id=02227122&scoped=true&"
import script from "./send-add-mobile.vue?vue&type=script&lang=js&"
export * from "./send-add-mobile.vue?vue&type=script&lang=js&"
import style0 from "./send-add-mobile.vue?vue&type=style&index=0&id=02227122&lang=scss&scoped=true&"
import style1 from "./send-add-mobile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02227122",
  null
  
)

export default component.exports